<template>
  <footer id="footer">
    <div id="copyright">
      <a href="https://www.marketenterprise.co.jp/" target="_blank">
        <img
          src="@/assets/common_me_logo.svg"
          alt="MarketEnterprise"
          class="footer_logo"
        />
      </a>
      <p>{{ corp_name }}<br>{{ haddress_zip }} {{ haddress_pref }}{{ haddress_address }}<br>{{ haddress_building }}</p>
      <ul>
        <li v-for="n in kouan_numbers" :key="n">{{ n }}</li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import settings from "../settings";
export default {
  data() {
    return {
      corp_name: settings.companyData[0].corp_name,
      corp_name_en: settings.companyData[0].corp_name_en,
      haddress_zip: settings.companyData[0].head_office_zip,
      haddress_pref: settings.companyData[0].head_office_pref,
      haddress_address: settings.companyData[0].head_office_address,
      haddress_building: settings.companyData[0].head_office_building,
      kouan_numbers: settings.companyData[0].kouan_numbers,
      copyright: settings.companyData[0].copyright
    };
  },
  name: "footer-bar",
  computed: {
    ...mapGetters(["current_offer"]),
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FooterBar.vue